function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighBondStrength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.25,54.58c5.6-2.93,11.2-5,17.5-3.66,6.78,1.42,11.3,6.65,12.45,14.28a27.47,27.47,0,0,1-.72,11.62c-1.41,5-4.37,7.37-9.65,7.48a27.22,27.22,0,0,1-14-4c-1.54-.87-2.51-.83-3.84.47-5.14,5-11.6,7-18.58,7.38-11.62.61-22.19-2.92-32.2-8.5a3,3,0,0,1-1.64-3.27C12.12,61.54,15.81,47,23.24,33.68a92.08,92.08,0,0,1,11.62-15.9,16.75,16.75,0,0,1,9.86-5.93,9.05,9.05,0,0,1,9.47,4.53A5.31,5.31,0,0,1,53.55,23c-2.44,2.88-5.72,3.87-9.34,4-.65,0-1.3,0-2-.08a8.16,8.16,0,0,0-7.47,3.59c-4.28,5.82-5.71,12.41-5.63,19.44a48.45,48.45,0,0,0,1.57,11.6c.65,2.5,1.25,2.72,3.37,1.15,7-5.18,14.74-7.5,23.42-5.82A12.25,12.25,0,0,1,67.64,69.74c0,.92,0,1.77,1.09,1.86s1.37-.88,1.46-1.8c.52-5.52-3-11.69-8.16-14.35-.52-.27-1.06-.52-1.79-.87ZM86.67,68.87a17.91,17.91,0,0,0-.4-3.46C85.14,58.89,81.12,55,75,54.54c-1-.08-2.06-.15-2.19,1.17S73.71,57,74.62,57c4.34.3,7.36,2.3,8.65,6.63a19.06,19.06,0,0,1-.51,12.71c-.35.89-.66,1.8.48,2.24s1.57-.48,1.9-1.33A23.25,23.25,0,0,0,86.67,68.87ZM42.2,84.26c1.12-.09,2.25-.15,3.36-.29,5.29-.67,10.1-2.43,13.95-6.3.66-.66,1.32-1.4.41-2.25s-1.61-.34-2.31.36a19.68,19.68,0,0,1-11.13,5.43c-1.69.27-3.41.38-5.11.52-.88.07-1.59.39-1.55,1.33s.81,1.21,1.67,1.2Zm5.5-67.7c-.15-1.21-1-1.34-2-1.24-3.48.38-5.93,2.49-8.2,4.9-.69.74-1.3,1.63-.35,2.44s1.6-.13,2.22-.77c2-2.08,4.08-4,7.2-4.14.69,0,1-.56,1.09-1.2Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.74,44.31c-.2.5-.44,1.1-.7,1.69-.76,1.73-1.52,3.45-2.31,5.17a1.3,1.3,0,0,1-1.91.71c-.74-.37-.84-1-.49-1.82,1-2.09,1.86-4.21,2.8-6.3a1.24,1.24,0,0,1,1.55-.83,1.34,1.34,0,0,1,1,1.38Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.35,43a1.55,1.55,0,0,1,1.46,1c.88,2,1.75,4,2.64,6,.37.83.27,1.57-.55,2a1.39,1.39,0,0,1-2-.87c-.86-2-1.73-4-2.52-6-.39-1-.21-1.88,1-2Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.12,44.12c0,1,0,2,0,3a1.13,1.13,0,0,1-1.18,1.26,1.16,1.16,0,0,1-1.3-1.17c-.06-2.24,0-4.49,0-6.73a1.1,1.1,0,0,1,1.17-1.1,1.14,1.14,0,0,1,1.27,1.18c0,1.18,0,2.36,0,3.54h0Z",
    style: {
      fill: "#E66C00"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighBondStrength);
export default __webpack_public_path__ + "static/media/high-bond-strength.bc27c0014806c99d2f6ded6941b5a79f.svg";
export { ForwardRef as ReactComponent };